import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_dollar",
  "use": "icon-icon_dollar-usage",
  "viewBox": "0 0 17 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 20\" id=\"icon-icon_dollar\"><path fill=\"#33343D\" d=\"M9.716 19.992v-4.256h4.732V14H9.716v-2.408l.028-.028h4.704V9.828h-3.724L16.184 0h-3.696L8.092 8.596 3.696 0H0l5.46 9.828H1.764v1.736H6.44l.028.028V14H1.764v1.736h4.704v4.256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol